import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";

/* eslint-disable @typescript-eslint/no-shadow */
import { readProviderCookie, readSignupCookie } from '../utils/referralProgram';
import { http } from './http';

var ProviderService = /*#__PURE__*/function () {
  function ProviderService() {
    _classCallCheck(this, ProviderService);
  }

  _createClass(ProviderService, [{
    key: "getProviderServiceBySlug",
    value: function () {
      var _getProviderServiceBySlug = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(serviceSlug, passwordHash) {
        var queryParams, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                queryParams = passwordHash ? "?passwordHash=".concat(passwordHash) : '';
                _context.next = 3;
                return http.get("/provider-service/s/".concat(serviceSlug).concat(queryParams));

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getProviderServiceBySlug(_x, _x2) {
        return _getProviderServiceBySlug.apply(this, arguments);
      }

      return getProviderServiceBySlug;
    }()
  }, {
    key: "getProviderServiceById",
    value: function () {
      var _getProviderServiceById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return http.get("/provider-service/".concat(payload));

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getProviderServiceById(_x3) {
        return _getProviderServiceById.apply(this, arguments);
      }

      return getProviderServiceById;
    }()
  }, {
    key: "getProviderServiceByProviderId",
    value: function () {
      var _getProviderServiceByProviderId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(providerId, passwordHash) {
        var queryParams, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                queryParams = passwordHash ? "?passwordHash=".concat(passwordHash) : '';
                _context3.next = 3;
                return http.get("/provider-service/".concat(providerId, "/provider").concat(queryParams));

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", result.data);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getProviderServiceByProviderId(_x4, _x5) {
        return _getProviderServiceByProviderId.apply(this, arguments);
      }

      return getProviderServiceByProviderId;
    }()
  }, {
    key: "createProviderService",
    value: function () {
      var _createProviderService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return http.post("/provider-service", payload);

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", result.data);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function createProviderService(_x6) {
        return _createProviderService.apply(this, arguments);
      }

      return createProviderService;
    }()
  }, {
    key: "createServiceProspect",
    value: function () {
      var _createServiceProspect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return http.post("/provider-service/".concat(payload.serviceId, "/prospects"), payload);

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", result.data);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function createServiceProspect(_x7) {
        return _createServiceProspect.apply(this, arguments);
      }

      return createServiceProspect;
    }()
  }, {
    key: "getServiceProspects",
    value: function () {
      var _getServiceProspects = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(serviceId, options) {
        var query, result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                query = options !== null && options !== void 0 && options.filterServiceProspects ? "/?filterProspects=".concat(options.filterServiceProspects) : '';
                _context6.next = 3;
                return http.get("/provider-service/".concat(serviceId, "/prospects").concat(query));

              case 3:
                result = _context6.sent;
                return _context6.abrupt("return", result.data);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function getServiceProspects(_x8, _x9) {
        return _getServiceProspects.apply(this, arguments);
      }

      return getServiceProspects;
    }()
  }, {
    key: "getServiceProspectCount",
    value: function () {
      var _getServiceProspectCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/prospects-count"));

              case 2:
                result = _context7.sent;
                return _context7.abrupt("return", result.data);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getServiceProspectCount(_x10) {
        return _getServiceProspectCount.apply(this, arguments);
      }

      return getServiceProspectCount;
    }()
  }, {
    key: "getUserRelationShipToService",
    value: function () {
      var _getUserRelationShipToService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/user-type"));

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", result.data);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function getUserRelationShipToService(_x11) {
        return _getUserRelationShipToService.apply(this, arguments);
      }

      return getUserRelationShipToService;
    }()
  }, {
    key: "unsubscribeFromEmailing",
    value: function () {
      var _unsubscribeFromEmailing = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload) {
        var campaignQuery, result;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                campaignQuery = payload !== null && payload !== void 0 && payload.campaignId ? "/?campaignId=".concat(payload === null || payload === void 0 ? void 0 : payload.campaignId) : '';
                _context9.next = 3;
                return http.post("/provider-service/".concat(payload.serviceId, "/prospect-unsubscribe/").concat(payload.token).concat(campaignQuery));

              case 3:
                result = _context9.sent;
                return _context9.abrupt("return", result.data);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function unsubscribeFromEmailing(_x12) {
        return _unsubscribeFromEmailing.apply(this, arguments);
      }

      return unsubscribeFromEmailing;
    }()
  }, {
    key: "providerServiceUnsubscribeFromEmailing",
    value: function () {
      var _providerServiceUnsubscribeFromEmailing = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return http.post("/provider-service/".concat(payload.serviceId, "/provider-unsubscribe/").concat(payload.emailType));

              case 2:
                result = _context10.sent;
                return _context10.abrupt("return", result.data);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function providerServiceUnsubscribeFromEmailing(_x13) {
        return _providerServiceUnsubscribeFromEmailing.apply(this, arguments);
      }

      return providerServiceUnsubscribeFromEmailing;
    }()
  }, {
    key: "subscriberUnsubscribeFromEmails",
    value: function () {
      var _subscriberUnsubscribeFromEmails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payload) {
        var campaignQuery, result;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                campaignQuery = payload !== null && payload !== void 0 && payload.campaignId ? "/?campaignId=".concat(payload === null || payload === void 0 ? void 0 : payload.campaignId) : '';
                _context11.next = 3;
                return http.post("/provider-service/".concat(payload.serviceId, "/subscriber-unsubscribe/").concat(payload.token).concat(campaignQuery));

              case 3:
                result = _context11.sent;
                return _context11.abrupt("return", result.data);

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function subscriberUnsubscribeFromEmails(_x14) {
        return _subscriberUnsubscribeFromEmails.apply(this, arguments);
      }

      return subscriberUnsubscribeFromEmails;
    }()
  }, {
    key: "confirmServiceProspect",
    value: function () {
      var _confirmServiceProspect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return http.get("/provider-service/".concat(payload.serviceId, "/prospect-confirm/").concat(payload.token));

              case 2:
                result = _context12.sent;
                return _context12.abrupt("return", result.data);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function confirmServiceProspect(_x15) {
        return _confirmServiceProspect.apply(this, arguments);
      }

      return confirmServiceProspect;
    }()
  }, {
    key: "getProviderSurvey",
    value: function () {
      var _getProviderSurvey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return http.get("/survey/".concat(payload));

              case 2:
                result = _context13.sent;
                return _context13.abrupt("return", result.data);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function getProviderSurvey(_x16) {
        return _getProviderSurvey.apply(this, arguments);
      }

      return getProviderSurvey;
    }()
  }, {
    key: "getPlanSurvey",
    value: function () {
      var _getPlanSurvey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(planId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return http.get("/survey/plan/".concat(planId));

              case 2:
                result = _context14.sent;
                return _context14.abrupt("return", result.data);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function getPlanSurvey(_x17) {
        return _getPlanSurvey.apply(this, arguments);
      }

      return getPlanSurvey;
    }()
  }, {
    key: "getAllAnswersForPlan",
    value: function () {
      var _getAllAnswersForPlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(planId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return http.get("/survey/plan/".concat(planId, "/answers"));

              case 2:
                result = _context15.sent;
                return _context15.abrupt("return", result.data);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function getAllAnswersForPlan(_x18) {
        return _getAllAnswersForPlan.apply(this, arguments);
      }

      return getAllAnswersForPlan;
    }()
  }, {
    key: "submitSurveyAnswers",
    value: function () {
      var _submitSurveyAnswers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(payload) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return http.post("/survey/".concat(payload.surveyId, "/answers"), payload.surveyAnswers);

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function submitSurveyAnswers(_x19) {
        return _submitSurveyAnswers.apply(this, arguments);
      }

      return submitSurveyAnswers;
    }()
  }, {
    key: "createSurvey",
    value: function () {
      var _createSurvey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return http.post("/survey", payload);

              case 2:
                result = _context17.sent;
                return _context17.abrupt("return", result.data);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function createSurvey(_x20) {
        return _createSurvey.apply(this, arguments);
      }

      return createSurvey;
    }()
  }, {
    key: "updateSurvey",
    value: function () {
      var _updateSurvey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return http.put("/survey", payload);

              case 2:
                result = _context18.sent;
                return _context18.abrupt("return", result.data);

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function updateSurvey(_x21) {
        return _updateSurvey.apply(this, arguments);
      }

      return updateSurvey;
    }()
  }, {
    key: "getProviderBySlug",
    value: function () {
      var _getProviderBySlug = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(providerSlug) {
        var result;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return http.get("/provider/".concat(providerSlug));

              case 2:
                result = _context19.sent;
                return _context19.abrupt("return", result.data);

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function getProviderBySlug(_x22) {
        return _getProviderBySlug.apply(this, arguments);
      }

      return getProviderBySlug;
    }()
  }, {
    key: "getPosts",
    value: function () {
      var _getPosts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/posts"));

              case 2:
                result = _context20.sent;
                return _context20.abrupt("return", result.data);

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function getPosts(_x23) {
        return _getPosts.apply(this, arguments);
      }

      return getPosts;
    }()
  }, {
    key: "getPost",
    value: function () {
      var _getPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(serviceId, postId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/posts/").concat(postId));

              case 2:
                result = _context21.sent;
                return _context21.abrupt("return", result.data);

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      function getPost(_x24, _x25) {
        return _getPost.apply(this, arguments);
      }

      return getPost;
    }()
  }, {
    key: "getPostBySlug",
    value: function () {
      var _getPostBySlug = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(serviceSlug, postSlug) {
        var result;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return http.get("/provider-service/s/".concat(serviceSlug, "/posts/").concat(postSlug));

              case 2:
                result = _context22.sent;
                return _context22.abrupt("return", result.data);

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      function getPostBySlug(_x26, _x27) {
        return _getPostBySlug.apply(this, arguments);
      }

      return getPostBySlug;
    }()
  }, {
    key: "getRevenueReport",
    value: function () {
      var _getRevenueReport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(serviceId, numberOfDays) {
        var result;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/revenue-last-days?numberOfDays=").concat(numberOfDays));

              case 2:
                result = _context23.sent;
                return _context23.abrupt("return", _objectSpread(_objectSpread({}, result.data), {}, {
                  serviceId: serviceId
                }));

              case 4:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));

      function getRevenueReport(_x28, _x29) {
        return _getRevenueReport.apply(this, arguments);
      }

      return getRevenueReport;
    }()
  }, {
    key: "getSessionBySlug",
    value: function () {
      var _getSessionBySlug = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(serviceSlug, sessionSlug) {
        var result;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return http.get("/provider-service/s/".concat(serviceSlug, "/session/").concat(sessionSlug));

              case 2:
                result = _context24.sent;
                return _context24.abrupt("return", result.data);

              case 4:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      function getSessionBySlug(_x30, _x31) {
        return _getSessionBySlug.apply(this, arguments);
      }

      return getSessionBySlug;
    }()
  }, {
    key: "createPost",
    value: function () {
      var _createPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(serviceId, post) {
        var result;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return http.post("/provider-service/".concat(serviceId, "/posts"), post);

              case 2:
                result = _context25.sent;
                return _context25.abrupt("return", result.data);

              case 4:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));

      function createPost(_x32, _x33) {
        return _createPost.apply(this, arguments);
      }

      return createPost;
    }()
  }, {
    key: "updatePost",
    value: function () {
      var _updatePost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(serviceId, postId, post) {
        var result;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return http.put("/provider-service/".concat(serviceId, "/posts/").concat(postId), post);

              case 2:
                result = _context26.sent;
                return _context26.abrupt("return", result.data);

              case 4:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }));

      function updatePost(_x34, _x35, _x36) {
        return _updatePost.apply(this, arguments);
      }

      return updatePost;
    }()
  }, {
    key: "deletePost",
    value: function () {
      var _deletePost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(serviceId, postId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return http["delete"]("/provider-service/".concat(serviceId, "/posts/").concat(postId));

              case 2:
                result = _context27.sent;
                return _context27.abrupt("return", result.data);

              case 4:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));

      function deletePost(_x37, _x38) {
        return _deletePost.apply(this, arguments);
      }

      return deletePost;
    }()
  }, {
    key: "emailPost",
    value: function () {
      var _emailPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(serviceId, postId, target, planIds) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return http.post("/provider-service/".concat(serviceId, "/email/").concat(postId, "/campaign"), {
                  target: target,
                  planIds: planIds
                });

              case 2:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));

      function emailPost(_x39, _x40, _x41, _x42) {
        return _emailPost.apply(this, arguments);
      }

      return emailPost;
    }()
  }, {
    key: "createEmailCampaign",
    value: function () {
      var _createEmailCampaign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(serviceId, emailCampaign) {
        var result;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return http.post("/provider-service/".concat(serviceId, "/email-campaigns"), emailCampaign);

              case 2:
                result = _context29.sent;
                return _context29.abrupt("return", result.data);

              case 4:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));

      function createEmailCampaign(_x43, _x44) {
        return _createEmailCampaign.apply(this, arguments);
      }

      return createEmailCampaign;
    }()
  }, {
    key: "getEmailCampaign",
    value: function () {
      var _getEmailCampaign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(serviceId, emailCampaignId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/email/").concat(emailCampaignId));

              case 2:
                result = _context30.sent;
                return _context30.abrupt("return", result.data);

              case 4:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30);
      }));

      function getEmailCampaign(_x45, _x46) {
        return _getEmailCampaign.apply(this, arguments);
      }

      return getEmailCampaign;
    }()
  }, {
    key: "getEmailCampaignList",
    value: function () {
      var _getEmailCampaignList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/email-campaigns"));

              case 2:
                result = _context31.sent;
                return _context31.abrupt("return", result.data);

              case 4:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      }));

      function getEmailCampaignList(_x47) {
        return _getEmailCampaignList.apply(this, arguments);
      }

      return getEmailCampaignList;
    }()
  }, {
    key: "getSurveyResults",
    value: function () {
      var _getSurveyResults = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(surveyId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return http.get("/survey/".concat(surveyId, "/results"));

              case 2:
                result = _context32.sent;
                return _context32.abrupt("return", result.data);

              case 4:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));

      function getSurveyResults(_x48) {
        return _getSurveyResults.apply(this, arguments);
      }

      return getSurveyResults;
    }()
  }, {
    key: "getAllSurveyResults",
    value: function () {
      var _getAllSurveyResults = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(providerServiceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return http.get("/provider-service/".concat(providerServiceId, "/surveys"));

              case 2:
                result = _context33.sent;
                return _context33.abrupt("return", result.data);

              case 4:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33);
      }));

      function getAllSurveyResults(_x49) {
        return _getAllSurveyResults.apply(this, arguments);
      }

      return getAllSurveyResults;
    }()
  }, {
    key: "getSchedule",
    value: function () {
      var _getSchedule = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(payload) {
        var serviceId, startsAt, endsAt, result;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                serviceId = payload.serviceId, startsAt = payload.startsAt, endsAt = payload.endsAt;
                _context34.next = 3;
                return http.get("/provider-service/".concat(serviceId, "/schedule?startsAt=").concat(startsAt, "&endsAt=").concat(endsAt));

              case 3:
                result = _context34.sent;
                return _context34.abrupt("return", result.data);

              case 5:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34);
      }));

      function getSchedule(_x50) {
        return _getSchedule.apply(this, arguments);
      }

      return getSchedule;
    }()
  }, {
    key: "postTestEmail",
    value: function () {
      var _postTestEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(serviceId, postId) {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return http.post("/provider-service/".concat(serviceId, "/email/").concat(postId, "/test"));

              case 2:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35);
      }));

      function postTestEmail(_x51, _x52) {
        return _postTestEmail.apply(this, arguments);
      }

      return postTestEmail;
    }()
  }, {
    key: "getServicePlans",
    value: function () {
      var _getServicePlans = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(serviceId) {
        var shareCodes, query, result;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                shareCodes = readSignupCookie();
                query = '';

                if (shareCodes && shareCodes[serviceId]) {
                  query = "?shareCode=".concat(shareCodes[serviceId]);
                }

                _context36.next = 5;
                return http.get("/provider-service/".concat(serviceId, "/plans").concat(query));

              case 5:
                result = _context36.sent;
                return _context36.abrupt("return", result.data);

              case 7:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36);
      }));

      function getServicePlans(_x53) {
        return _getServicePlans.apply(this, arguments);
      }

      return getServicePlans;
    }()
  }, {
    key: "getServiceSubscriptions",
    value: function () {
      var _getServiceSubscriptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/subscriptions"));

              case 2:
                result = _context37.sent;
                return _context37.abrupt("return", result.data);

              case 4:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37);
      }));

      function getServiceSubscriptions(_x54) {
        return _getServiceSubscriptions.apply(this, arguments);
      }

      return getServiceSubscriptions;
    }()
  }, {
    key: "getServiceCustomersPromoTrue",
    value: function () {
      var _getServiceCustomersPromoTrue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/service-customers-promo-true"));

              case 2:
                result = _context38.sent;
                return _context38.abrupt("return", result.data);

              case 4:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38);
      }));

      function getServiceCustomersPromoTrue(_x55) {
        return _getServiceCustomersPromoTrue.apply(this, arguments);
      }

      return getServiceCustomersPromoTrue;
    }()
  }, {
    key: "getServiceCustomers",
    value: function () {
      var _getServiceCustomers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/service-customer"));

              case 2:
                result = _context39.sent;
                return _context39.abrupt("return", result.data);

              case 4:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39);
      }));

      function getServiceCustomers(_x56) {
        return _getServiceCustomers.apply(this, arguments);
      }

      return getServiceCustomers;
    }()
  }, {
    key: "createVerifiedServiceProspect",
    value: function () {
      var _createVerifiedServiceProspect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.next = 2;
                return http.post("/provider-service/".concat(payload.serviceId, "/verified-prospect"), payload);

              case 2:
                result = _context40.sent;
                return _context40.abrupt("return", result.data);

              case 4:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40);
      }));

      function createVerifiedServiceProspect(_x57) {
        return _createVerifiedServiceProspect.apply(this, arguments);
      }

      return createVerifiedServiceProspect;
    }()
  }, {
    key: "uploadProspectList",
    value: function () {
      var _uploadProspectList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(payload, options) {
        var serviceId, result;
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                serviceId = payload.get('serviceId');
                _context41.next = 3;
                return http.post("/provider-service/".concat(serviceId, "/upload-prospects"), payload, options);

              case 3:
                result = _context41.sent;
                return _context41.abrupt("return", result.data);

              case 5:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41);
      }));

      function uploadProspectList(_x58, _x59) {
        return _uploadProspectList.apply(this, arguments);
      }

      return uploadProspectList;
    }()
  }, {
    key: "updateProviderService",
    value: function () {
      var _updateProviderService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                _context42.next = 2;
                return http.patch("/provider-service/".concat(payload.id), payload);

              case 2:
                result = _context42.sent;
                return _context42.abrupt("return", result.data);

              case 4:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42);
      }));

      function updateProviderService(_x60) {
        return _updateProviderService.apply(this, arguments);
      }

      return updateProviderService;
    }()
  }, {
    key: "createProvider",
    value: function () {
      var _createProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(payload) {
        var cookie, result;
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                cookie = readProviderCookie();

                if (cookie) {
                  payload.referrerShareCode = cookie.shareCode;
                }

                _context43.next = 4;
                return http.post("/provider", payload);

              case 4:
                result = _context43.sent;
                return _context43.abrupt("return", result.data);

              case 6:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43);
      }));

      function createProvider(_x61) {
        return _createProvider.apply(this, arguments);
      }

      return createProvider;
    }()
  }, {
    key: "updateProvider",
    value: function () {
      var _updateProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _context44.next = 2;
                return http.patch("/provider/".concat(payload.id), payload);

              case 2:
                result = _context44.sent;
                return _context44.abrupt("return", result.data);

              case 4:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44);
      }));

      function updateProvider(_x62) {
        return _updateProvider.apply(this, arguments);
      }

      return updateProvider;
    }()
  }, {
    key: "getServiceTerms",
    value: function () {
      var _getServiceTerms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/service-terms"));

              case 2:
                result = _context45.sent;
                return _context45.abrupt("return", result.data);

              case 4:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45);
      }));

      function getServiceTerms(_x63) {
        return _getServiceTerms.apply(this, arguments);
      }

      return getServiceTerms;
    }()
  }, {
    key: "createServicePlan",
    value: function () {
      var _createServicePlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(plan) {
        var result;
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.next = 2;
                return http.post("/plan", plan);

              case 2:
                result = _context46.sent;
                return _context46.abrupt("return", result.data);

              case 4:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46);
      }));

      function createServicePlan(_x64) {
        return _createServicePlan.apply(this, arguments);
      }

      return createServicePlan;
    }() // note: this currently isn't passing up shareCode like getServicePlans above,
    // because currently only providers use this. If regular users / anonymous use this,
    // must add shareCode support also (for referred discounts to show up)

  }, {
    key: "getServicePlan",
    value: function () {
      var _getServicePlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(planId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _context47.next = 2;
                return http.get("/plan/".concat(planId));

              case 2:
                result = _context47.sent;
                return _context47.abrupt("return", result.data);

              case 4:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47);
      }));

      function getServicePlan(_x65) {
        return _getServicePlan.apply(this, arguments);
      }

      return getServicePlan;
    }()
  }, {
    key: "updatePlan",
    value: function () {
      var _updatePlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(planId, plan) {
        var result;
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                _context48.next = 2;
                return http.put("/plan/".concat(planId), plan);

              case 2:
                result = _context48.sent;
                return _context48.abrupt("return", result.data);

              case 4:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48);
      }));

      function updatePlan(_x66, _x67) {
        return _updatePlan.apply(this, arguments);
      }

      return updatePlan;
    }()
  }, {
    key: "deletePlan",
    value: function () {
      var _deletePlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(serviceId, planId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                _context49.next = 2;
                return http["delete"]("/plan/".concat(planId), {
                  data: {
                    serviceId: serviceId
                  }
                });

              case 2:
                result = _context49.sent;
                return _context49.abrupt("return", result.data);

              case 4:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49);
      }));

      function deletePlan(_x68, _x69) {
        return _deletePlan.apply(this, arguments);
      }

      return deletePlan;
    }()
  }, {
    key: "deletePlanFeature",
    value: function () {
      var _deletePlanFeature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(serviceId, planId, featureId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _context50.next = 2;
                return http["delete"]("/plan/".concat(planId, "/features/").concat(featureId), {
                  data: {
                    serviceId: serviceId
                  }
                });

              case 2:
                result = _context50.sent;
                return _context50.abrupt("return", result.data);

              case 4:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50);
      }));

      function deletePlanFeature(_x70, _x71, _x72) {
        return _deletePlanFeature.apply(this, arguments);
      }

      return deletePlanFeature;
    }()
  }, {
    key: "activatePlan",
    value: function () {
      var _activatePlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(serviceId, planId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                _context51.next = 2;
                return http.put("/provider-service/".concat(serviceId, "/plans/").concat(planId, "/activate"));

              case 2:
                result = _context51.sent;
                return _context51.abrupt("return", result.data);

              case 4:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51);
      }));

      function activatePlan(_x73, _x74) {
        return _activatePlan.apply(this, arguments);
      }

      return activatePlan;
    }()
  }, {
    key: "deactivatePlan",
    value: function () {
      var _deactivatePlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(serviceId, planId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                _context52.next = 2;
                return http.put("/provider-service/".concat(serviceId, "/plans/").concat(planId, "/deactivate"));

              case 2:
                result = _context52.sent;
                return _context52.abrupt("return", result.data);

              case 4:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52);
      }));

      function deactivatePlan(_x75, _x76) {
        return _deactivatePlan.apply(this, arguments);
      }

      return deactivatePlan;
    }()
  }, {
    key: "emailSessionAttendees",
    value: function () {
      var _emailSessionAttendees = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(serviceId, sessionId, payload) {
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.next = 2;
                return http.post("/provider-service/".concat(serviceId, "/email-attendees/").concat(sessionId), payload);

              case 2:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53);
      }));

      function emailSessionAttendees(_x77, _x78, _x79) {
        return _emailSessionAttendees.apply(this, arguments);
      }

      return emailSessionAttendees;
    }()
  }, {
    key: "getActiveReferralProgram",
    value: function () {
      var _getActiveReferralProgram = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                _context54.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/referral-program"));

              case 2:
                result = _context54.sent;
                return _context54.abrupt("return", result.data);

              case 4:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54);
      }));

      function getActiveReferralProgram(_x80) {
        return _getActiveReferralProgram.apply(this, arguments);
      }

      return getActiveReferralProgram;
    }()
  }, {
    key: "getReferralProgramsForService",
    value: function () {
      var _getReferralProgramsForService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                _context55.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/referral-programs"));

              case 2:
                result = _context55.sent;
                return _context55.abrupt("return", result.data);

              case 4:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55);
      }));

      function getReferralProgramsForService(_x81) {
        return _getReferralProgramsForService.apply(this, arguments);
      }

      return getReferralProgramsForService;
    }()
  }, {
    key: "getServicePostMailingList",
    value: function () {
      var _getServicePostMailingList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(serviceId, postId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                _context56.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/post-mailing-list/").concat(postId));

              case 2:
                result = _context56.sent;
                return _context56.abrupt("return", result.data);

              case 4:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56);
      }));

      function getServicePostMailingList(_x82, _x83) {
        return _getServicePostMailingList.apply(this, arguments);
      }

      return getServicePostMailingList;
    }()
  }, {
    key: "createServiceTerms",
    value: function () {
      var _createServiceTerms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                _context57.next = 2;
                return http.post("/provider-service/".concat(payload.serviceId, "/service-terms"), payload);

              case 2:
                result = _context57.sent;
                return _context57.abrupt("return", result.data);

              case 4:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57);
      }));

      function createServiceTerms(_x84) {
        return _createServiceTerms.apply(this, arguments);
      }

      return createServiceTerms;
    }()
  }, {
    key: "updateServiceTerms",
    value: function () {
      var _updateServiceTerms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.next = 2;
                return http.put("/provider-service/".concat(payload.serviceId, "/service-terms"), payload);

              case 2:
                result = _context58.sent;
                return _context58.abrupt("return", result.data);

              case 4:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58);
      }));

      function updateServiceTerms(_x85) {
        return _updateServiceTerms.apply(this, arguments);
      }

      return updateServiceTerms;
    }()
  }, {
    key: "getAllProviders",
    value: function () {
      var _getAllProviders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59() {
        var result;
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.next = 2;
                return http.get("/provider");

              case 2:
                result = _context59.sent;
                return _context59.abrupt("return", result.data);

              case 4:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59);
      }));

      function getAllProviders() {
        return _getAllProviders.apply(this, arguments);
      }

      return getAllProviders;
    }()
  }, {
    key: "createPlanProspect",
    value: function () {
      var _createPlanProspect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(dto) {
        var result;
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.next = 2;
                return http.post("/plan/planprospect", dto);

              case 2:
                result = _context60.sent;
                return _context60.abrupt("return", result.data);

              case 4:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60);
      }));

      function createPlanProspect(_x86) {
        return _createPlanProspect.apply(this, arguments);
      }

      return createPlanProspect;
    }()
  }, {
    key: "getPlanProspectsForPlan",
    value: function () {
      var _getPlanProspectsForPlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(dto) {
        var result;
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.next = 2;
                return http.get("/provider-service/".concat(dto.serviceId, "/plans/").concat(dto.planId, "/planprospects"));

              case 2:
                result = _context61.sent;
                return _context61.abrupt("return", result.data);

              case 4:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61);
      }));

      function getPlanProspectsForPlan(_x87) {
        return _getPlanProspectsForPlan.apply(this, arguments);
      }

      return getPlanProspectsForPlan;
    }()
  }, {
    key: "getPlanProspectsForService",
    value: function () {
      var _getPlanProspectsForService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                _context62.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/planprospects"));

              case 2:
                result = _context62.sent;
                return _context62.abrupt("return", result.data);

              case 4:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62);
      }));

      function getPlanProspectsForService(_x88) {
        return _getPlanProspectsForService.apply(this, arguments);
      }

      return getPlanProspectsForService;
    }()
  }, {
    key: "updateServiceProspects",
    value: function () {
      var _updateServiceProspects = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(dto) {
        var result;
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                _context63.next = 2;
                return http.put("/provider-service/".concat(dto.serviceId, "/prospects"), dto.body);

              case 2:
                result = _context63.sent;
                return _context63.abrupt("return", result.data);

              case 4:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63);
      }));

      function updateServiceProspects(_x89) {
        return _updateServiceProspects.apply(this, arguments);
      }

      return updateServiceProspects;
    }()
  }, {
    key: "getStripeAccountStatus",
    value: function () {
      var _getStripeAccountStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/stripe-account-status"));

              case 2:
                result = _context64.sent;
                return _context64.abrupt("return", result.data);

              case 4:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64);
      }));

      function getStripeAccountStatus(_x90) {
        return _getStripeAccountStatus.apply(this, arguments);
      }

      return getStripeAccountStatus;
    }()
  }]);

  return ProviderService;
}();

var providerService = new ProviderService();
export default providerService;